import cloneDeep from 'lodash/cloneDeep';
import { COUNTDOWN_DEFAULT_PROPS } from './countdown/countdown';

// defaultWidgets are created & added automatically upon event creation
export const defaultWidgets = [
	{
		type: 'Media',
	},
	{
		type: 'Announcements',
	},
	{
		type: 'Pinned',
	},
];

// widget default properties are set here
export const widgetTypes = [
	{
		type: 'Header',
		description: 'Insert a header',
		props: {
			headerText: 'Header',
			alignment: 'left',
			headerSize: 'medium',
			// dividerSize: 'medium',
			headerColor: '#000000',
			dividerColor: '#000000',
		},
		groups: [],
	},
	{
		type: 'Text',
		description: 'Insert a text block',
		props: {
			text: 'Hello!',
		},
		groups: [],
	},
	{
		type: 'Media',
		description: 'Displays an image or gif',
		props: {
			onPress: {},
		},
		groups: [],
	},
	{
		type: 'Button',
		description: 'Inserts up to 2 buttons in a row',
		props: {
			amount: '1',
			buttons: [
				{
					onPress: {},
					buttonColor: '#AAAAAA',
					textColor: '#FFFFFF',
					size: 'default',
					position: 'left',
					text: '',
					source: '',
				},
			],
		},
		groups: [],
	},
	{
		type: 'Icon',
		description: 'Inserts up to 4 icons in a row',
		props: {
			amount: '1',
			alignment: 'left',
			size: 'small',
			icons: [],
		},
		groups: [],
	},
	{
		type: 'Divider',
		description: 'Insert a divider between items',
		props: {
			type: 'solid',
			source: '',
			size: 'medium',
			color: '#000000',
		},
		groups: [],
	},
	{
		type: 'Spacer',
		description: 'Displays a blank space for separation',
		groups: [],
	},
	{
		type: 'Announcements',
		description: 'Displays up to two unread announcements',
		groups: [],
	},
	{
		type: 'Pinned',
		description: 'Displays up to two pinned items either from announcements or social feed',
		groups: [],
	},
	{
		type: 'Social Feed',
		description: 'Displays most recent social feed posts with or without a filtered hashtag',
		props: { include_headers: true },
		groups: [],
	},
	{
		type: 'Agenda',
		description: "Displays the attendee's personalized agenda items",
		props: { include_headers: true },
		groups: [],
	},
	{
		type: 'Countdown',
		description: 'Counts down to a date and time you pick',
		props: COUNTDOWN_DEFAULT_PROPS,
		groups: [],
	},
	{
		type: 'Checklist',
		description: 'A checklist attendees tick off',
		props: { checklist_id: null, show: 'current', full_checklist_on_press: {} },
		groups: [],
	},
];

export const withDropDefaults = (widget, page) =>
	widget.type === 'Checklist'
		? { ...widget, props: { ...widget.props, show: page ? 'all' : 'current' } }
		: widget;

export const getWidgetType = type => widgetTypes.find(widget => widget.type === type);

export const getWidgetTypeProps = type => cloneDeep(getWidgetType(type)?.props || {});
